export default {
  SET_DEALER_ZONES: (state, data) => {
    state.dealer_zones = data;
  },
  SET_DEALER_ZONE: (state, data) => {
    state.dealer_zone = data;
  },
};
